/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {issueAuthenticatedWebSession} from '../api'

export const useMutationIssueAuthenticatedWebSession = createReactQueryMutationHook('issueAuthenticatedWebSession', issueAuthenticatedWebSession)
